import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	OnDestroy,
	Output,
	ViewChild,
	ElementRef
} from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { DragulaService } from 'ng2-dragula';
import { MessageService } from '@services/helpers/message-service/message.service';
import { SettingsProvider } from '@services/settings/settings';
import { JobType } from '@models/models';

@Component({
	selector: 'drag-and-drop-block',
	template: require('./drag-and-drop-block.html'),
	styles: [require('./drag-and-drop-block.scss')]
})
export class DragAndDropBlockComponent implements OnInit, OnDestroy {
	// common
	@Input() buttonDisabled: boolean;

	// recent-leads-block
	@Input() addNewLeadSpinningWheel: boolean;
	@Output()
	sendEmailModalTrigger: EventEmitter<object> = new EventEmitter<object>();
	@Output()
	editLeadModalTrigger: EventEmitter<object> = new EventEmitter<object>();
	@Output()
	addNewLeadModalTrigger: EventEmitter<void> = new EventEmitter<void>();

	// shoots-appointment-block
	@Input() isAddNewSpinnningWheelActive: boolean;
	@Output() chooseModalTrigger: EventEmitter<any> = new EventEmitter<any>();

	// job-task-block
	@Output() editJobModalTrigger: EventEmitter<any> = new EventEmitter<any>();

	// graphs-block
	@Input() jobTypes: JobType[];

	@ViewChild('container') container: ElementRef;
	unsubscribe: Subject<void> = new Subject<void>();
	oldPanelsPosition: Array<string> = [];
	draggablePanels: Array<string> = [];
	draggableBlocks: Array<string> = [];
	dragulaPanelsOptions = {
		moves: (el, container, handle): boolean =>
			handle.className === 'handlePanel',
		direction: 'horizontal'
	};
	dragulaBlocksOptions = {
		moves: (el, container, handle): boolean =>
			handle.className === 'handle-block'
	};

	constructor(
		private dragulaService: DragulaService,
		private settingsService: SettingsProvider,
		private messageService: MessageService
	) {}

	ngOnInit(): void {
		this.setDragulaOptions();
		this.subscribeToPanelsPosition();
	}

	ngOnDestroy(): void {
		this.clear();
		this.dragulaService.destroy('draggablePanels');
		this.dragulaService.destroy('draggableBlocks');
	}

	// recent-leads-block
	sendEmailModalHandler(mailData): void {
		this.sendEmailModalTrigger.emit(mailData);
	}

	editLeadModalHandler(leadData): void {
		this.editLeadModalTrigger.emit(leadData);
	}

	showAddNewLeadModal(): void {
		this.addNewLeadModalTrigger.emit();
	}

	// shoots-appointment-block
	chooseModalHandler(event): void {
		this.chooseModalTrigger.emit(event);
	}

	// job tasks with due date
	editJobModalHandler(leadData): void {
		this.editJobModalTrigger.emit(leadData);
	}

	// drag-and-drop-block
	private subscribeToPanelsPosition(): void {
		this.settingsService.panelsPositionObservable
			.takeUntil(this.unsubscribe)
			.subscribe(
				(panelsPosition): void => {
					if (panelsPosition.panelsPosition !== null) {
						this.setPanelsPosition(panelsPosition);
					}
				},
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private setDragulaOptions(): void {
		this.dragulaService.setOptions(
			'draggablePanels',
			this.dragulaPanelsOptions
		);
		this.dragulaService.setOptions(
			'draggableBlocks',
			this.dragulaBlocksOptions
		);
		this.dragulaService.drag.takeUntil(this.unsubscribe).subscribe((): void => {
			Object.assign(this.dragulaPanelsOptions, {
				mirrorContainer: this.container.nativeElement
			});
		});
		this.dragulaService.dragend
			.takeUntil(this.unsubscribe)
			.subscribe((): void => {
				this.savePanelsPosition(this.draggablePanels);
			});
	}

	private setPanelsPosition(panelsPosition): void {
		this.draggableBlocks =
			panelsPosition.panels.indexOf('charts_panel') === 0
				? ['graphs', 'panels']
				: ['panels', 'graphs'];
		this.draggablePanels = panelsPosition.panels.filter(
			(panel): boolean => panel !== 'charts_panel'
		);
		this.oldPanelsPosition = this.draggablePanels.slice();
	}

	private savePanelsPosition(panelsPosition): void {
		this.draggableBlocks.indexOf('graphs') === 0
			? panelsPosition.unshift('charts_panel')
			: panelsPosition.push('charts_panel');
		this.settingsService
			.savePanelsPosition(panelsPosition)
			.subscribe(
				(result): void => console.log(result),
				(error): void => this.messageService.showDefaultErrorMessage(error)
			);
	}

	private clear(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/dashboard/drag-and-drop-block/drag-and-drop-block.ts